import { render, staticRenderFns } from "./SuggestedLinks.vue?vue&type=template&id=68ba1f90&scoped=true&"
import script from "./SuggestedLinks.vue?vue&type=script&lang=js&"
export * from "./SuggestedLinks.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedLinks.vue?vue&type=style&index=0&id=68ba1f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba1f90",
  null
  
)

export default component.exports